/* Signature card variations: directional edge fade for the carousel layout.
   A side fades only while it still hides thumbnails, so the first thumbnail is crisp at rest and the fade
   appears as you swipe. Rows added later (filters, infinite scroll, recommendations) are picked up by a
   MutationObserver; a hidden row (width 0) is skipped and repainted by its ResizeObserver once it shows. */
(function () {
  'use strict';

  var SELECTOR = '.signature-card-variations--carousel';
  var FADE = 'var(--card-variation-fade)';
  var observed = new WeakSet();
  var resizeObserver = 'ResizeObserver' in window ? new ResizeObserver(function (entries) {
    entries.forEach(function (entry) { paint(entry.target); });
  }) : null;

  function paint(row) {
    if (row.clientWidth === 0) {
      return;
    }

    var max = row.scrollWidth - row.clientWidth;
    var left = Math.abs(row.scrollLeft);
    row.style.setProperty('--fade-left', left > 1 ? FADE : '0px');
    row.style.setProperty('--fade-right', left < max - 1 ? FADE : '0px');
  }

  function attach(root) {
    var rows = [];
    if (root.matches && root.matches(SELECTOR)) {
      rows.push(root);
    }
    if (root.querySelectorAll) {
      rows = rows.concat(Array.prototype.slice.call(root.querySelectorAll(SELECTOR)));
    }

    rows.forEach(function (row) {
      paint(row);
      if (resizeObserver && !observed.has(row)) {
        observed.add(row);
        resizeObserver.observe(row);
      }
    });
  }

  document.addEventListener('scroll', function (event) {
    if (event.target.matches && event.target.matches(SELECTOR)) {
      paint(event.target);
    }
  }, { capture: true, passive: true });

  function init() {
    attach(document);

    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) {
            attach(node);
          }
        });
      });
    }).observe(document.body, { childList: true, subtree: true });

    window.addEventListener('load', function () { attach(document); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
